import { render, staticRenderFns } from "./ReviewModalNew.vue?vue&type=template&id=8cd1b8c6"
import script from "./ReviewModalNew.vue?vue&type=script&lang=ts"
export * from "./ReviewModalNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cd1b8c6')) {
      api.createRecord('8cd1b8c6', component.options)
    } else {
      api.reload('8cd1b8c6', component.options)
    }
    module.hot.accept("./ReviewModalNew.vue?vue&type=template&id=8cd1b8c6", function () {
      api.rerender('8cd1b8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/ReviewModalNew.vue"
export default component.exports